import contact1 from "../../assets/contact1.svg";
import contact2 from "../../assets/contact2.svg";
import contact3 from "../../assets/contact3.svg";
import contact4 from "../../assets/contact4.svg";

import { Typography, Box } from "@mui/material";

import SectionHeader from "../../components/SectionHeader";
import PageLoader from "../../components/PageLoader";
import {
  ContactModalitemSx,
  ContactModalSx,
  InformationSx,
  modalStyle,
  PhoneTiposx,
  WrapperBoxSx,
} from "./styles";
import { useInfo } from "../../hooks/useInfo";

const ContactPage = () => {
  const { data: info, isLoading, error } = useInfo();

  return (
    <PageLoader isLoading={isLoading} error={error} errorMessage="Failed to load contact information">
      <Box sx={WrapperBoxSx}>
        <Box sx={modalStyle}>
          <SectionHeader
            title={"Contact"}
            description={"Below you can find our Contact infromation"}
          />
          <Box sx={ContactModalSx}>
            <Box sx={ContactModalitemSx}>
              <Box component="img" src={contact3} alt="phone" />
              <Typography variant="h1" component="h2" sx={PhoneTiposx}>
                Phone
              </Typography>
              <Typography variant="h1" component="h2" sx={InformationSx}>
                {info?.phoneNumber}
              </Typography>
            </Box>
            <Box sx={ContactModalitemSx}>
              <Box component="img" src={contact2} alt="email" />
              <Typography variant="h1" component="h2" sx={PhoneTiposx}>
                E-mail
              </Typography>
              <Typography variant="h1" component="h2" sx={InformationSx}>
                {info?.email}
              </Typography>
            </Box>
            <Box sx={ContactModalitemSx}>
              <Box component="img" src={contact4} alt="facebook" />
              <Typography variant="h1" component="h2" sx={PhoneTiposx}>
                Facebook
              </Typography>
              <Typography variant="h1" component="h2" sx={InformationSx}>
                {info?.facebook}
              </Typography>
            </Box>
            <Box sx={ContactModalitemSx}>
              <Box component="img" src={contact1} alt="instagram" />
              <Typography variant="h1" component="h2" sx={PhoneTiposx}>
                Instagram
              </Typography>
              <Typography variant="h1" component="h2" sx={InformationSx}>
                {info?.instagram}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </PageLoader>
  );
};

export default ContactPage;
